export default "__VITE_ASSET__Cw92F2P4__"